import { ReactElement, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { ModalWindow } from '~/components';
import { DamScheduleForm } from '../ScheduleForm';
import { DamScheduleFormValues } from '../ScheduleForm/types';
import { ModalWrapper, ScheduleModalContainer } from './styles';

interface DamScheduleFormModalProps {
  open: boolean;
  defaultValues?: DamScheduleFormValues;
  type: 'schedule' | 'exception';
  onClose: () => void;
  onSuccess: (data: DamScheduleFormValues, type: 'schedule' | 'exception') => void;
}

export function DamScheduleFormModal({
  open,
  defaultValues,
  onClose,
  onSuccess,
  type,
}: Readonly<DamScheduleFormModalProps>): ReactElement | null {
  const { t } = useTranslation();

  function getTitle(): string {
    const mode = defaultValues ? t('editar') : t('botaoAdicionar');

    return t(type === 'schedule' ? 'editarAdicionarProgramacao' : 'editarAdicionarExcecao', {
      value: mode,
    });
  }

  useEffect(() => {
    const root = document.querySelector('#root') as HTMLDivElement;
    if (open) {
      root.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    } else {
      root.style.overflow = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      root.style.overflow = 'auto';
    };
  }, [open]);

  if (!open) return null;

  return (
    <ModalWrapper>
      <ModalWindow
        borderTop
        onClickOutside={onClose}
        style={{ padding: '0px', minWidth: 500, width: 'auto' }}
      >
        <ScheduleModalContainer>
          <h4 style={{
            fontWeight: 'bold',
            fontSize: '120%',
            alignSelf: 'flex-start',
            margin: 0,
          }}
          >
            {getTitle()}
          </h4>
          <DamScheduleForm
            defaultValues={defaultValues}
            type={type}
            onCancel={onClose}
            onSuccess={onSuccess}
          />
        </ScheduleModalContainer>
      </ModalWindow>
    </ModalWrapper>
  );
}
